import React, { useEffect, useRef, useState } from 'react'
import Icons from '../icons/Icons'
import Button from './Button'
import { useId } from 'react'

const CollapsableButton = ( props ) => {
    const [ isCollapsed, setIsCollapsed ] = useState( props.collapsed ?? false ) 
    const ref = useRef(null)
    const buttonID = useId()
    const showHeader = props.showPanelHeader ? true : false

    useEffect(() => {
      setIsCollapsed(false)
    }, [props.setClosed])

    function handleClickOutside(event){
      if (ref && ref.current && !ref.current.contains(event.target)) {
        setIsCollapsed(false);
      }
    }
    
    useEffect(() => {
      if( ref ){
        document.addEventListener("mousedown", handleClickOutside)
      }
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [ ref ])

    return (
      <div 
        className={`msync-dropdown ${props.className ? props.className : ''}`}
        ref={ ref }
      >
        <button 
          className={`msync-dropdown__trigger msync-button ${props.buttonClassName ? props.buttonClassName : 'msync-button--is-theme-secondary msync-button--is-style-outline'}`} 
          disabled={ props.disabled ?? null } 
          onClick={()=> setIsCollapsed((prev) => !prev)}
          aria-expanded={ isCollapsed ? 'true' : 'false' }
          aria-haspopup="true" 
          id={ buttonID }
        >
            { props.icon && (
                <Icons type={props.icon} />
            )}
            <span>{ props.title ?? '' }</span>
            <Icons type={ isCollapsed ? 'arrow-up' : 'arrow-down' } />
        </button>
        {  ( isCollapsed && props.children ) && (
          <div className='msync-dropdown__panel' aria-labelledby={ buttonID }>
            {  ( showHeader ) && (
            <div class="msync-dropdown__panel__header">
              <span>{ props.title }</span>
              <Button
                className='msync-dropdown__panel__action-exit' 
                onClick={()=> setIsCollapsed((prev) => !prev)}
              >
                <span className="msync-visually-hidden">Close</span>
                <Icons type='close' />
              </Button>
            </div>
            )}
            { props.children }
          </div>
        )}
      </div>
    )
}

export default CollapsableButton
